/* El Ropero de la Anita — muestra datos del producto sin inventarlos.
   El botón Comprar ahora usa la variante seleccionada y el carrito/checkout de Shopify. */
(function () {
  function initAnitaProduct() {
    var bar = document.querySelector('[data-anita-sticky-purchase]');
    if (!bar) return;
    var sectionId = bar.getAttribute('data-anita-section');
    var info = document.getElementById('ProductInfo-' + sectionId);
    if (!info) return;
    document.body.classList.add('anita-product-active');
    // Shopify muestra una barra de vista previa sobre el pie de página.
    var isPreview = (window.location.search || '').indexOf('preview_theme_id=') !== -1
      || Boolean(document.querySelector('#preview-bar-iframe,iframe[src*="preview_bar"],iframe[id*="preview"]'));
    if (isPreview) document.body.classList.add('anita-theme-preview');
    function checkPreviewBar() {
      if (document.querySelector('#preview-bar-iframe,iframe[id*="preview"],iframe[src*="preview_bar"]')) {
        document.body.classList.add('anita-theme-preview');
      }
    }
    checkPreviewBar();
    window.setTimeout(checkPreviewBar, 350);

    var submit = info.querySelector('.product-form__submit[name="add"]');
    var stickyButton = bar.querySelector('[data-anita-sticky-button]');
    if (submit && stickyButton && !stickyButton.dataset.anitaReady) {
      stickyButton.dataset.anitaReady = '1';
      stickyButton.addEventListener('click', async function () {
        var current = document.getElementById('ProductInfo-' + sectionId);
        var nativeButton = current && current.querySelector('.product-form__submit[name="add"]');
        var form = current && current.querySelector('form[data-type="add-to-cart-form"]');
        if (!nativeButton || nativeButton.disabled || !form) {
          if (nativeButton) nativeButton.scrollIntoView({behavior:'smooth', block:'center'});
          return;
        }
        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return;
        stickyButton.disabled = true;
        stickyButton.textContent = 'Preparando compra…';
        try {
          var formData = new FormData(form);
          formData.set('quantity','1');
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {'Accept':'application/json'},
            body: formData
          });
          if (!response.ok) {
            var failure = await response.json().catch(function () {return {};});
            throw new Error(failure.description || 'No se pudo agregar la prenda al carrito.');
          }
          window.location.assign('/checkout');
        } catch (error) {
          stickyButton.disabled = false;
          stickyButton.textContent = 'Comprar ahora';
          window.alert(error && error.message ? error.message : 'No fue posible iniciar la compra. Inténtalo nuevamente.');
        }
      });
      var sync = function () {
        var current = document.getElementById('ProductInfo-' + sectionId);
        var nativeButton = current && current.querySelector('.product-form__submit[name="add"]');
        if (!nativeButton) return;
        stickyButton.disabled = nativeButton.disabled;
        stickyButton.textContent = nativeButton.disabled ? 'Agotado' : 'Comprar ahora';
        var inlineMain = current.querySelector('.anita-inline-purchase__buy');
        var inlineCart = current.querySelector('.anita-inline-purchase__cart');
        if (inlineMain) {
          inlineMain.disabled = nativeButton.disabled;
          inlineMain.textContent = nativeButton.disabled ? 'Agotado' : 'Comprar ahora';
        }
        if (inlineCart) inlineCart.disabled = nativeButton.disabled;
        var price = current.querySelector('[id^="price-"] .price-item--sale');
        if (!price || !price.offsetParent) price = current.querySelector('[id^="price-"] .price__regular .price-item--regular');
        var priceTag = bar.querySelector('[data-anita-sticky-price] strong');
        if (price && priceTag) priceTag.textContent = price.textContent.trim();
      };
      sync();
      var observer = new MutationObserver(sync);
      observer.observe(submit, {attributes:true, attributeFilter:['disabled']});
      info.addEventListener('change', function () {window.setTimeout(sync, 150);});
    }

    if (!info.querySelector('.anita-product-points')) {
      var priceBlock = info.querySelector('[id^="price-"]');
      if (!priceBlock) return;
      var description = info.querySelector('.product__description');
      var text = description ? description.textContent.replace(/\s+/g,' ') : '';
      var descriptionLines = description ? (description.innerHTML || '').replace(/<br\s*\/?\s*>/gi, '\n').replace(/<\/(?:p|li|div|h[1-6])\s*>/gi, '\n').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').split(/\r?\n/).map(function(line){return line.trim();}) : [];
      var title = info.querySelector('.product__title h1');
      // ANITA COLOR SWATCH 2026-10
      // The garment's catalog title remains unchanged for SEO and orders.
      var titleText = title ? title.textContent.trim() : '';
      // ANITA SIZE 3X FIX — consume the entire size token (3X, 2XL, 3XL, 3T, XLT, 38.5, 32x32).
      var sizePattern = /\bTALLA(?:\s+EN\s+ETIQUETA)?\s*:?\s*(W\s*\d{1,3}\s+L\s*\d{1,3}|[A-Z0-9]+(?:[.,xX\/\-][A-Z0-9]+)*)(?:\s*\(\s*\d{1,2}\s*\/\s*\d{1,2}\s*\))?/i;
      var sizeMatch = titleText.match(sizePattern);
      var sizeValue = sizeMatch ? sizeMatch[1].replace(/\s+/g, ' ').toUpperCase() : '';
      if (!sizeValue) {
        var sizeFromDescription = descriptionLines.join('\n').match(/(?:^|\n)\s*[•\-]?\s*Talla(?:\s+en\s+etiqueta)?\s*[:：]\s*([^\n\r]+)/i);
        if (sizeFromDescription) sizeValue = sizeFromDescription[1].trim().replace(/\s+/g, ' ').slice(0, 20);
      }
      if (title && sizeMatch) {
        var displayTitle = titleText
          .replace(sizePattern, ' ')
          .replace(/\s*[·•|]\s*$/g, '')
          .replace(/\s+/g, ' ').trim();
        if (displayTitle) {
          title.textContent = displayTitle;
          var duplicateHeading = info.querySelector('.product__title h2');
          if (duplicateHeading) duplicateHeading.textContent = displayTitle;
        }
      }
      // El HTML <br> puede unir "9.5/10" con la palabra siguiente.
      // Evitar el límite de palabra tras "10": 10Chaqueta también es válido.
      var stateMatch = text.match(/\bEstado\s*[:：]?\s*(\d{1,2}(?:[.,]\d)?\s*\/\s*10)(?!\d)/i);

      // The color field is created from the actual garment when each product
      // is cataloged. Never infer color from the photo's background or the model.
      var productColor = '';
      if (description) {
        var explicitColorLine = descriptionLines.find(function (line) {
          return /^\s*[•\-]?\s*Color(?:\s+de\s+(?:la\s+)?prenda)?\s*[:：]/i.test(line);
        });
        if (explicitColorLine) productColor = explicitColorLine.replace(/^\s*[•\-]?\s*Color(?:\s+de\s+(?:la\s+)?prenda)?\s*[:：]\s*/i, '').trim();
      }
      if (!productColor) {
        // Use title color only when the fabric shade is explicit.
        var colorFromTitle = titleText.match(/\b(?:azul\s+marino|azul\s+oscuro|gris\s+jaspeado|gris\s+oscuro|verde\s+oliva|verde\s+musgo|blanco|negro|beige|camel|mostaza|burdeo|fucsia|turquesa|celeste|rosado|rojo|azul|verde|morado|naranja|naranjo|café|cafe|crema|amarillo|lila)\b/ig);
        if (colorFromTitle) productColor = colorFromTitle.join(' / ');
      }
      var normalizeColor = function (value) {
        return (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      };
      var photoColorPalette = [
        {pattern:/rose gold|oro rosa/,name:'Rosa dorado',hex:'#B87D75'},
        {pattern:/azul marino|navy blue|navy/,name:'Azul marino',hex:'#172C4D'},
        {pattern:/azul oscuro/,name:'Azul oscuro',hex:'#263C64'},
        {pattern:/celeste|azul cielo/,name:'Celeste',hex:'#91D0ED'},
        {pattern:/turquesa/,name:'Turquesa',hex:'#35A8B3'},
        {pattern:/azul/,name:'Azul',hex:'#386BC2'},
        {pattern:/gris oscuro|grafito/,name:'Gris oscuro',hex:'#4D535C'},
        {pattern:/gris claro/,name:'Gris claro',hex:'#B3B6B9'},
        {pattern:/gris|plomo/,name:'Gris',hex:'#858B94'},
        {pattern:/negro/,name:'Negro',hex:'#1B1C20'},
        {pattern:/blanco crudo|blanco roto/,name:'Blanco crudo',hex:'#F2EEE5'},
        {pattern:/blanco/,name:'Blanco',hex:'#FFFFFF'},
        {pattern:/crema|marfil/,name:'Crema',hex:'#F2E4CD'},
        {pattern:/beige/,name:'Beige',hex:'#CBB99C'},
        {pattern:/camel|caramelo/,name:'Camel',hex:'#B78B59'},
        {pattern:/terracota/,name:'Terracota',hex:'#B96D56'},
        {pattern:/cafe|marron/,name:'Café',hex:'#77513D'},
        {pattern:/burdeo|borgona|vino|granate/,name:'Burdeo',hex:'#752F42'},
        {pattern:/carmesi|rojo/,name:'Rojo',hex:'#CB3C43'},
        {pattern:/fucsia/,name:'Fucsia',hex:'#D92F87'},
        {pattern:/rosado|rosa|salmon/,name:'Rosado',hex:'#E4A5AF'},
        {pattern:/lila/,name:'Lila',hex:'#A58AC9'},
        {pattern:/morado|violeta/,name:'Morado',hex:'#7B559C'},
        {pattern:/verde oliva|oliva/,name:'Verde oliva',hex:'#777C4C'},
        {pattern:/verde musgo/,name:'Verde musgo',hex:'#667A57'},
        {pattern:/verde menta/,name:'Verde menta',hex:'#A7D8BE'},
        {pattern:/verde lima/,name:'Verde lima',hex:'#B4D833'},
        {pattern:/verde/,name:'Verde',hex:'#458367'},
        {pattern:/naranja|naranjo|coral/,name:'Naranja',hex:'#E77E48'},
        {pattern:/mostaza/,name:'Mostaza',hex:'#C59C37'},
        {pattern:/amarillo/,name:'Amarillo',hex:'#E7C947'},
        {pattern:/dorado|gold/,name:'Dorado',hex:'#C8A05B'},
        {pattern:/plateado|silver/,name:'Plateado',hex:'#C6CBD0'}
      ];
      var colorText = normalizeColor(productColor);
      var colorHits = photoColorPalette
        .map(function (color) {
          var found = colorText.match(color.pattern);
          return found ? {name:color.name,hex:color.hex,index:found.index,group:color.name.split(' ')[0]} : null;
        })
        .filter(Boolean)
        .sort(function (a,b) {return a.index-b.index;});
      // Prefer the specific shade (e.g. navy) over the generic color.
      var uniqueColorHits = [];
      colorHits.forEach(function (hit) {
        if (!uniqueColorHits.some(function (item) {return item.group === hit.group;}))
          uniqueColorHits.push(hit);
      });
      uniqueColorHits = uniqueColorHits.slice(0,3);
      var swatchBackground = '';
      if (uniqueColorHits.length === 1) {
        swatchBackground = uniqueColorHits[0].hex;
      } else if (uniqueColorHits.length > 1) {
        swatchBackground = 'conic-gradient(' + uniqueColorHits.map(function (color,i) {
          var from = Math.round(i * 100 / uniqueColorHits.length);
          var to = Math.round((i+1) * 100 / uniqueColorHits.length);
          return color.hex + ' ' + from + '% ' + to + '%';
        }).join(',') + ')';
      }

      // ANITA HIDE REPEATED TITLE COLORS — presentation only, never change catalog data.
      // Only suppress colors when the same item's visible color chip is available.
      if (title && swatchBackground && productColor) {
        var colorTitleRules = [
          ['azul\\s+marino', 'azul marino'],
          ['azul\\s+oscuro', 'azul oscuro'],
          ['azul\\s+turquesa', 'azul\\s+turquesa'],
          ['gris\\s+(?:oscuro|claro|jaspeado)', 'gris'],
          ['verde\\s+(?:oliva|musgo|menta|lima)', 'verde'],
          ['blanc[oa]s?', 'blanc'],
          ['negr[oa]s?', 'negr'],
          ['roj[oa]s?', 'roj'],
          ['rosad[oa]s?', 'rosad'],
          ['celeste', 'celeste'],
          ['turquesa', 'turquesa'],
          ['fucsia', 'fucsia'],
          ['mostaza', 'mostaza'],
          ['burdeo', 'burdeo'],
          ['beige', 'beige'],
          ['camel', 'camel'],
          ['caf[eé]', 'cafe'],
          ['crema', 'crema'],
          ['gris', 'gris'],
          ['azul', 'azul'],
          ['verde', 'verde'],
          ['morad[oa]s?', 'morad'],
          ['lila', 'lila'],
          ['naranj[oa]s?', 'naranj'],
          ['amarill[oa]s?', 'amarill'],
          ['terracota', 'terracota'],
          ['dorad[oa]s?', 'dorad'],
          ['platead[oa]s?', 'platead']
        ];
        var titleWithoutRepeatedColor = title.textContent.trim();
        colorTitleRules.forEach(function (entry) {
          if (!(new RegExp(entry[1], 'i')).test(colorText)) return;
          var safeWordBoundary = new RegExp('(^|[^a-zA-ZÁÉÍÓÚÜÑáéíóúüñ0-9])(?:' + entry[0] + ')(?![a-zA-ZÁÉÍÓÚÜÑáéíóúüñ0-9])', 'gi');
          titleWithoutRepeatedColor = titleWithoutRepeatedColor.replace(safeWordBoundary, '$1 ');
        });
        titleWithoutRepeatedColor = titleWithoutRepeatedColor
          .replace(/\s+[/·|,–—]\s+/g, ' ')
          .replace(/\s+-\s+/g, ' ')
          .replace(/(?:^|\s+)y(?=\s|$)/gi, ' ')
          .replace(/(?:\s+con\s+detalles)\s*$/i, '')
          .replace(/(?:\s+color)\s*$/i, '')
          .replace(/[\s·|/,-]+$/g, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (titleWithoutRepeatedColor.length > 7 && titleWithoutRepeatedColor !== title.textContent.trim()) {
          title.textContent = titleWithoutRepeatedColor;
          var secondTitle = info.querySelector('.product__title h2');
          if (secondTitle) secondTitle.textContent = titleWithoutRepeatedColor;
        }
      }
      var stock = Number(bar.getAttribute('data-anita-quantity'));
      var hasStock = bar.getAttribute('data-anita-quantity') !== '' && Number.isFinite(stock) && stock > 0 && stock <= 2;

      var points = document.createElement('div');
      points.className = 'anita-product-points';
      var addPoint = function (label, extraClass) {
        var item = document.createElement('span');
        item.className = 'anita-product-points__item' + (extraClass ? ' ' + extraClass : '');
        item.textContent = label;
        points.appendChild(item);
      };
      if (sizeValue) addPoint('Talla ' + sizeValue);
      if (swatchBackground) {
        var colorChip = document.createElement('span');
        colorChip.className = 'anita-product-points__item anita-product-points__item--color';
        colorChip.title = 'Color de la prenda: ' + productColor;
        var swatch = document.createElement('span');
        swatch.className = 'anita-product-points__swatch';
        swatch.style.background = swatchBackground;
        swatch.setAttribute('aria-hidden', 'true');
        var colorLabel = document.createElement('span');
        colorLabel.className = 'anita-product-points__color-label';
        colorLabel.textContent = uniqueColorHits.map(function (c) {return c.name;}).join(' / ');
        colorChip.append(swatch,colorLabel);
        points.appendChild(colorChip);
      } else {
        // If the description doesn't contain a color, use the garment's real
        // Shopify product photo. The photo always gives a visual swatch;
        // when CDN CORS permits, replace its central sample with a solid tone.
        var mainPhoto = document.querySelector('#MediaGallery-' + sectionId + ' .product__media-item img');
        var photoUrl = mainPhoto ? (mainPhoto.currentSrc || mainPhoto.src || mainPhoto.getAttribute('src')) : '';
        if (photoUrl) {
          var inferredColorBadge = document.createElement('span');
          inferredColorBadge.className = 'anita-product-points__item anita-product-points__item--color';
          inferredColorBadge.title = 'Tono de referencia tomado de la fotografía de la prenda';
          var inferredColorCircle = document.createElement('span');
          inferredColorCircle.className = 'anita-product-points__swatch';
          inferredColorCircle.setAttribute('aria-hidden', 'true');
          inferredColorCircle.style.backgroundColor = '#d6dbe4';
          inferredColorCircle.style.backgroundImage = 'url("' + photoUrl.replace(/"/g, '%22') + '")';
          inferredColorCircle.style.backgroundPosition = 'center center';
          inferredColorCircle.style.backgroundSize = 'cover';
          var inferredColorText = document.createElement('span');
          inferredColorText.className = 'anita-product-points__color-label';
          inferredColorText.textContent = 'Color (foto)';
          inferredColorBadge.append(inferredColorCircle, inferredColorText);
          points.appendChild(inferredColorBadge);
          var garmentPhoto = new Image();
          garmentPhoto.crossOrigin = 'anonymous';
          garmentPhoto.onload = function () {
            try {
              var canvas = document.createElement('canvas');
              canvas.width = 60;
              canvas.height = 60;
              var ctx = canvas.getContext('2d', {willReadFrequently:true});
              if (!ctx) return;
              ctx.drawImage(garmentPhoto, 0, 0, 60, 60);
              var data = ctx.getImageData(0,0,60,60).data;
              var groups = {};
              // The central portion is more likely to be the garment than
              // white studio backgrounds, labels or areas around a model.
              for (var yy=13;yy<46;yy+=2) for (var xx=16;xx<44;xx+=2) {
                var i = (yy*60+xx)*4, red=data[i], green=data[i+1], blue=data[i+2];
                var bright = Math.max(red,green,blue), dark = Math.min(red,green,blue);
                if (bright>239 && dark>222) continue;
                if (red>114 && red>green*1.20 && green>blue*1.16) continue;
                if (bright<18) continue;
                var key = [Math.round(red/25),Math.round(green/25),Math.round(blue/25)].join('_');
                if (!groups[key]) groups[key]={count:0,r:0,g:0,b:0};
                groups[key].count+=1;
                groups[key].r+=red;
                groups[key].g+=green;
                groups[key].b+=blue;
              }
              var winner=null;
              Object.keys(groups).forEach(function(key) {
                if (!winner || groups[key].count>winner.count) winner=groups[key];
              });
              if (!winner || winner.count<5) return;
              var rgb='rgb('+Math.round(winner.r/winner.count)+','+
                Math.round(winner.g/winner.count)+','+
                Math.round(winner.b/winner.count)+')';
              inferredColorCircle.style.backgroundImage = 'none';
              inferredColorCircle.style.backgroundColor = rgb;
              inferredColorText.textContent = 'Tono aprox.';
              inferredColorBadge.title = 'Tono aproximado calculado a partir de la foto de la prenda';
            } catch (error) {
              // Some photos cannot be sampled across origins. Their visible
              // thumbnail stays inside the circular swatch instead.
            }
          };
          garmentPhoto.src = photoUrl;
        }
      }
      // La etiqueta y/o variante Shopify son la fuente principal del estado.
      // El servidor lo muestra antes de que cargue JavaScript y aquí lo
      // movemos junto a talla, color y stock sin duplicarlo.
      var stateBadge = info.querySelector('[data-anita-state-badge]');
      if (stateBadge) points.appendChild(stateBadge);
      else if (stateMatch) addPoint('Estado ' + stateMatch[1].replace(/\s+/g, ''));
      if (hasStock) addPoint(stock === 1 ? '1 unidad disponible' : '2 unidades disponibles','anita-product-points__item--stock');
      if (points.children.length) priceBlock.insertAdjacentElement('afterend', points);

      var getMeasure = function (regex) {
        var m = text.match(regex);
        return m ? m[1].replace(/\s+/g,' ') : '';
      };
      // Lee medidas con o sin dos puntos: «Ancho: 45 cm» y «Ancho 45 cm».
      // También reconoce «Mangas 53 cm» además de «Largo de mangas: 53 cm».
      var widthMatch = text.match(/\bAncho(?:\s+(?:de\s+)?(cintura|pretina|cadera|pecho|sisa))?\s*[:：]?\s*(\d+(?:[.,]\d+)?\s*cm)\b/i);
      var width = widthMatch ? widthMatch[2].replace(/\s+/g,' ') : '';
      var lowerGarment = /\bcalzas?\b|\bleggings?\b|\bpantal[oó]n(?:es)?\b|\bjogg?ers?\b|\bjeans?\b|\bshorts?\b|\bbermudas?\b/i.test(titleText);
      var widthLabel = widthMatch && widthMatch[1] ? 'Ancho ' + widthMatch[1].toLowerCase() : (lowerGarment ? 'Ancho cintura' : 'Ancho');
      var length = getMeasure(/\bLargo(?:\s+total|\s+de\s+(?:pierna|prenda))?\s*[:：]?\s*(\d+(?:[.,]\d+)?\s*cm)\b/i);
      var sleeves = getMeasure(/\b(?:Largo\s*(?:de\s*)?(?:las\s*)?)?(?:mangas?|brazos?)\s*[:：]?\s*(\d+(?:[.,]\d+)?\s*cm)\b/i);
      var rise = getMeasure(/\bTiro\s*[:：]?\s*(\d+(?:[.,]\d+)?\s*cm)\b/i);
      var measures = [];
      if (width) measures.push(widthLabel + ' ' + width);
      if (length) measures.push('Largo ' + length);
      if (rise && lowerGarment) measures.push('Tiro ' + rise);
      if (sleeves) measures.push('Mangas ' + sleeves);
      if (measures.length) {
        var box = document.createElement('div');
        box.className = 'anita-product-measures';
        var heading = document.createElement('strong');
        heading.textContent = 'Medidas de la prenda';
        var values = document.createElement('span');
        values.textContent = measures.join(' · ');
        box.append(heading, values);
        if (points.children.length) points.insertAdjacentElement('afterend', box);
        else priceBlock.insertAdjacentElement('afterend', box);
      }
      // CTA principal visible antes de las tarjetas de medios de pago y beneficios.
      var anchor = info.querySelector('.anita-product-measures') || info.querySelector('.anita-product-points') || priceBlock;
      if (anchor && !info.querySelector('.anita-inline-purchase')) {
        var panel = document.createElement('div');
        panel.className = 'anita-inline-purchase';
        var buy = document.createElement('button');
        buy.type = 'button';
        buy.className = 'anita-inline-purchase__buy';
        buy.textContent = submit && submit.disabled ? 'Agotado' : 'Comprar ahora';
        buy.disabled = Boolean(submit && submit.disabled);
        buy.addEventListener('click', function () {
          if (stickyButton && !stickyButton.disabled) stickyButton.click();
        });
        var cart = document.createElement('button');
        cart.type = 'button';
        cart.className = 'anita-inline-purchase__cart';
        cart.textContent = 'Agregar al carrito';
        cart.disabled = Boolean(submit && submit.disabled);
        cart.addEventListener('click', function () {
          var nativeButton = info.querySelector('.product-form__submit[name="add"]');
          if (nativeButton && !nativeButton.disabled) nativeButton.click();
        });
        var trust = document.createElement('p');
        trust.className = 'anita-inline-purchase__trust';
        trust.textContent = 'Envíos a todo Chile · Compra segura · Moda circular';
        panel.append(buy, cart, trust);
        anchor.insertAdjacentElement('afterend', panel);
      }

      // Conserva la información de la tienda, pero evita duplicar los cuadros enormes
      // cuando ya se presentan estos beneficios en una sola línea junto a la compra.
      function compressLegacyBlocks() {
        var candidates = Array.prototype.slice.call(info.querySelectorAll('h2,h3,h4,strong,p,span,div'));
        var titleLeaf = candidates.find(function (el) {
          return el.children.length === 0 && el.textContent.trim().replace(/\s+/g, ' ').toUpperCase() === 'MODA CIRCULAR';
        });
        if (titleLeaf) {
          var node = titleLeaf;
          for (var level = 0; level < 7 && node && node !== info; level++, node = node.parentElement) {
            var total = (node.textContent || '').replace(/\s+/g, ' ').toUpperCase();
            if (total.includes('MODA CIRCULAR') && total.includes('COMPRA CON CONFIANZA') &&
                total.includes('ENVÍOS A') && total.length < 650 &&
                !node.querySelector('form,button') && node !== info) {
              node.classList.add('anita-large-benefits');
              break;
            }
          }
        }
        // Identifica únicamente un contenedor pequeño con los tres logos, sin tocar otros bloques.
        var imgs = Array.prototype.slice.call(info.querySelectorAll('img'));
        var logo = imgs.find(function(img) { return /mastercard/i.test((img.alt || '') + ' ' + (img.src || '')); });
        if (logo) {
          var box = logo.parentElement;
          for (var level2 = 0; level2 < 6 && box && box !== info; level2++,box = box.parentElement) {
            var logos = Array.prototype.slice.call(box.querySelectorAll('img')).map(function(img){
              return ((img.alt || '') + ' ' + (img.src || '')).toLowerCase();
            }).join(' ');
            if (logos.includes('mastercard') && logos.includes('visa') &&
                /mercado.?pago/.test(logos) && box.querySelectorAll('img').length <= 6 &&
                !box.querySelector('form,button')) {
              box.classList.add('anita-large-payment-icons');
              break;
            }
          }
        }
      }
      compressLegacyBlocks();
      window.setTimeout(compressLegacyBlocks, 550);
      window.setTimeout(compressLegacyBlocks, 1900);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAnitaProduct);
  else initAnitaProduct();
  document.addEventListener('shopify:section:load', initAnitaProduct);
})();